import React, { useState } from 'react';
import ToolkitComparePage from './toolkit/ToolkitComparePage';

// Sync › project › Toolkit › AR Ledger Comparison — ported from the desktop's Scripts › AR Ledger Comparison. The v5 and
// Opera Cloud AR Ledger Aging Detailed reports, account by account: an invoice matches on the same post date and
// amount, partially on the same date within 0.99; the rest is missing in Cloud, or Cloud only (toolkit compare.js
// ar-ledger).

const money = (v) => (v == null ? '—' : Number(v).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
const COLUMNS = [
    { key: 'accountNo', label: 'AR No' },
    { key: 'accountName', label: 'Account' },
    { key: 'postDate', label: 'Post date' },
    { key: 'invoice', label: 'Invoice' },
    { key: 'guestName', label: 'Guest' },
    { key: 'v5Amount', label: 'v5', render: (r) => money(r.v5Amount) },
    { key: 'cloudAmount', label: 'Cloud', render: (r) => money(r.cloudAmount) },
    { key: 'difference', label: 'Difference', render: (r) => money(r.difference) },
];
const STATUSES = [{ value: 'partial', label: 'Partial' }, { value: 'missing', label: 'Missing in Cloud' }, { value: 'cloud-only', label: 'Cloud only' }];
const summaryOf = (s) => [
    { label: 'v5 total', value: money(s.v5Amount) }, { label: 'Cloud total', value: money(s.cloudAmount) },
    { label: 'Difference', value: money(s.cloudAmount - s.v5Amount), tone: Math.abs(s.cloudAmount - s.v5Amount) < 0.005 ? 'ok' : 'fail' },
    { label: 'Matched invoices', value: s.match, tone: 'ok' }, { label: 'Partial', value: `${s.partial} (${money(s.partialDifference)})`, tone: 'warn' },
    { label: 'Missing in Cloud', value: `${s.missing} (${money(s.missingAmount)})`, tone: 'fail' }, { label: 'Cloud only', value: s.cloudOnly },
];

function ToolkitArLedgerComparisonPage() {
    const [excludeZero, setExcludeZero] = useState(true);
    return (
        <ToolkitComparePage title="AR Ledger Comparison"
            subtitle="Compare the v5 AR Ledger Aging Detailed report with Opera Cloud's, invoice by invoice."
            kind="ar-ledger" accept=".xml,.rep,.csv,.txt" exportName="AR_Ledger_Comparison"
            v5Title="Opera v5 AR Ledger Aging Detailed" v5Label="Choose the v5 report (XML or CSV)"
            cloudTitle="Opera Cloud AR Ledger Aging Detailed" cloudLabel="Choose the Cloud report (XML or CSV)"
            columns={COLUMNS} statuses={STATUSES} summaryOf={summaryOf} optionValues={{ excludeZero }}
            options={(
                <label className="tkb-check">
                    <input type="checkbox" checked={excludeZero} onChange={(e) => setExcludeZero(e.target.checked)} />
                    <span>Leave out zero balances</span>
                </label>
            )} />
    );
}

export default ToolkitArLedgerComparisonPage;
